export default __webpack_public_path__ + "media/zurb/img/legacy/axe/4-b7c05ae089501c30313ec94a4c414b93.jpg";